import React from "react";
import { Button, ButtonVariant, clearSwitchedFrom } from "@merge-api/merge-javascript-shared";
import GoogleGLogo from "../../../../assets/svg/logos/google/google-g-logo.svg";
import { API_DOMAIN } from "../../../../api-client/APIClient";

interface Props {
  text?: string;
  loginHint?: string;
  disabled?: boolean;
  id?: string;
}

const GoogleSSOButton = ({ text = "Sign in with Google", loginHint, disabled, id }: Props) => {
  const baseUrl = `${API_DOMAIN}/sso/social/google/login`;
  const url = loginHint ? `${baseUrl}?login_hint=${encodeURIComponent(loginHint)}` : baseUrl;
  return (
    <Button
      id={id}
      type="button"
      variant={ButtonVariant.TertiaryWhite}
      fullWidth
      disabled={disabled}
      leftIcon={<img src={GoogleGLogo} alt="" className="h-6 w-6" />}
      onClick={() => {
        if (disabled) return;
        // merge-backend's google_callback sets the session cookie itself, so this click is the last
        // point where a direct sign-in can drop a product the tab switched in from.
        clearSwitchedFrom("unified");
        window.location.href = url;
      }}
    >
      {text}
    </Button>
  );
};

export default GoogleSSOButton;
